import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLine, FadeUp } from "@/components/Reveal";
import MagneticButton from "@/components/MagneticButton";

export default function FeaturedKerala() {
    const navigate = useNavigate();

    return (
        <section
            data-testid="featured-kerala-section"
            className="relative overflow-clip py-28 sm:py-36"
        >
            <div className="blueprint-grid pointer-events-none absolute inset-y-0 left-0 w-1/3 opacity-20 [mask-image:linear-gradient(to_right,black,transparent)]" />
            <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-6 sm:px-10 lg:grid-cols-2 lg:gap-20">
                <FadeUp y={60}>
                    <div className="group relative" data-cursor="hover">
                        <div className="absolute -left-4 -top-4 h-full w-full rounded-2xl border border-gold/30" />
                        <div className="relative overflow-hidden rounded-2xl border border-white/[0.08]">
                            <img
                                src="/images/kerala-courtyard.jpg"
                                alt="The Courtyard House — a Kerala courtyard residence with carved teak pillars, water court and rattan joinery"
                                loading="lazy"
                                className="h-[320px] w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105 sm:h-[460px]"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-coal/80 via-transparent to-transparent" />
                            <div className="absolute bottom-5 left-5">
                                <p className="text-[10px] font-medium uppercase tracking-[0.35em] text-gold">
                                    Featured Project · 2026
                                </p>
                                <p className="mt-1 font-display text-xl font-bold text-white">
                                    The Courtyard House — Kochi
                                </p>
                            </div>
                        </div>
                    </div>
                </FadeUp>

                <div>
                    <FadeUp y={20}>
                        <p className="flex items-center gap-4 text-[10px] font-medium uppercase tracking-[0.45em] text-ash">
                            <span className="h-px w-10 bg-gold" />
                            Why We Design
                        </p>
                    </FadeUp>
                    <h2 className="mt-8 font-display text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
                        <MaskedLine delay={0.05}>Designing spaces</MaskedLine>
                        <MaskedLine delay={0.15}>
                            <span className="text-gold">that matter.</span>
                        </MaskedLine>
                    </h2>
                    <FadeUp delay={0.3} className="mt-8 max-w-lg">
                        <p className="text-sm leading-relaxed text-ash sm:text-base">
                            Designing spaces that matter means focusing on
                            human emotion, well-being, and genuine connection
                            rather than just surface-level looks. It shapes how
                            we feel, think, and interact in our daily lives.
                        </p>
                    </FadeUp>
                    <FadeUp delay={0.4} className="mt-10">
                        <MagneticButton>
                            <button
                                data-testid="featured-kerala-btn"
                                onClick={() => navigate("/portfolio")}
                                className="group flex items-center gap-3 rounded-full border border-gold/50 px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-gold transition-colors duration-300 hover:bg-gold hover:text-coal"
                            >
                                See the Work
                                <ArrowUpRight
                                    size={16}
                                    className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                                />
                            </button>
                        </MagneticButton>
                    </FadeUp>
                </div>
            </div>
        </section>
    );
}
